import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../axiosBaseQuery";
import { FLEET_ENDPOINTS } from "../../../../api/constants";

/**
 * RTK Query API дашборда и флота EyeHub (провайдерская плоскость, IsHubStaff).
 *
 * `GET fleet/overview/` — агрегаты по ПОСЛЕДНЕМУ снимку каждой инсталляции
 * (фактический контракт `fleet.services.fleet_overview`):
 *   {
 *     total_installations: number,
 *     by_health: { ok: number, degraded: number, down: number },
 *     by_agent_version: { "<version>": number, ... },
 *     certs_expiring_soon: number,   // истекают в окне CERT_WARN_WINDOW (30 дн.)
 *     certs_expired: number
 *   }
 * Полей `organizations` / `installations` / `open_tickets` в ответе НЕТ —
 * счётчики организаций и тикетов берутся из `count` их собственных списков.
 * Для org-ролей эндпоинт отдаёт 403 (провайдерский дашборд без PHI).
 *
 * `GET fleet-snapshots/` — сами снимки телеметрии (drilldown «какая инсталляция
 * лежит»): {id, installation, agent_version, health, cert_expires_at, reported_at,
 * created_at}; сортировка по умолчанию `-reported_at`, фильтры `installation`
 * и `health`. Список — UnifiedOffsetPagination ({results, count, ...}).
 */
export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["FleetOverview", "FleetSnapshot"],
  endpoints: (builder) => ({
    getFleetOverview: builder.query({
      query: () => ({ url: FLEET_ENDPOINTS.OVERVIEW, method: "GET" }),
      providesTags: [{ type: "FleetOverview", id: "OVERVIEW" }],
    }),

    getFleetSnapshots: builder.query({
      query: ({ installation, health, limit = 20, offset = 0, ordering } = {}) => ({
        url: FLEET_ENDPOINTS.SNAPSHOTS,
        method: "GET",
        params: {
          limit,
          offset,
          ...(installation ? { installation } : {}),
          ...(health ? { health } : {}),
          ...(ordering ? { ordering } : {}),
        },
      }),
      providesTags: [{ type: "FleetSnapshot", id: "LIST" }],
    }),
  }),
});

export const { useGetFleetOverviewQuery, useGetFleetSnapshotsQuery } = dashboardApi;

export default dashboardApi;
